module.exports = __webpack_public_path__ + "static/media/blooz_angus.b8d02a35.png";